var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStarIconFilledred(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 8 35 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.88684 1.34998C9.34274 0.426227 10.66 0.426229 11.1159 1.34998L13.4224 6.02357L18.58 6.77302C19.5995 6.92115 20.0065 8.17391 19.2688 8.89295L15.5368 12.5308L16.4178 17.6676C16.5919 18.6829 15.5263 19.4572 14.6145 18.9778L10.0014 16.5525L5.38825 18.9778C4.47645 19.4572 3.41079 18.6829 3.58492 17.6676L4.46595 12.5308L0.733864 8.89295C-0.00379294 8.17391 0.403256 6.92115 1.42267 6.77302L6.58029 6.02357L8.88684 1.34998Z",
    fill: "#DD296E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarIconFilledred);
export default __webpack_public_path__ + "static/media/star_icon_filledred.f3d74b950c774ec6b1647eadd5d1ba08.svg";
export { ForwardRef as ReactComponent };